import React, { useState } from "react";
import Header from "./Header";

export default function ASNAndSKUDetails() {
  const [filterType, setFilterType] = useState("ASN");

  return (
    <div style={styles.pageContainer}>
      <Header title="ASN & SKU Details" />

      <div style={styles.card}>
        {/* Email input */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Enter Email ID</label>
          <input type="email" placeholder="Enter Email ID" style={styles.input} />
        </div>

        {/* Select ASN / SKU */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Select Type</label>
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            style={styles.input}
          >
            <option value="ASN">ASN</option>
            <option value="SKU">SKU</option>
          </select>
        </div>

        {/* ASN/SKU Number */}
        <div style={styles.formGroup}>
          <label style={styles.label}>{filterType} Number</label>
          <input
            type="text"
            placeholder={`Enter ${filterType} Number`}
            style={styles.input}
          />
        </div>

        {/* Search button */}
        <div style={styles.formGroup}>
          <button style={styles.searchBtn}>Search</button>
        </div>

        {/* Table */}
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th>ASN</th>
                <th>Order ID</th>
                <th>SKU</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: "1rem" }}>
                  No data available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: "100vh",
    background: "#f5f6fa",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    maxWidth: "700px",
    margin: "2rem auto",
    background: "#fff",
    padding: "2rem",
    borderRadius: "16px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
  },
  formGroup: {
    marginBottom: "1.5rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    fontWeight: "600",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  searchBtn: {
    width: "100%",
    padding: "1rem",
    backgroundColor: "#E30016",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  tableContainer: {
    marginTop: "2rem",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    background: "#f0f0f0",
  },
  th: {
    padding: "0.75rem",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
  },
  td: {
    padding: "0.75rem",
    borderBottom: "1px solid #eee",
  },
};
